import app from 'flarum/forum/app';

import extenders from './extenders';

import translator from '../common/components/TranslatorService';

app.initializers.add('xtreh-localize', () => {
    translator();
    extenders();
}, Number.MIN_VALUE);
